export default __webpack_public_path__ + "static/media/xwin-Team-Photos_fumi.788d1637.png";